

export const StageScriptOverlay = ({data, onClose}) => {



  return (
    <div className="scriptOverlay flex flex-col">

      <header className="flex justify-center items-center">
        <div className="flex-1 pt-2 pb-2">
          <div className="app-title flex-1">ANDERS SUNNA</div>
          <div className="app-subtitle"><i>Illegal Spirits of Sápmi</i> (2022)</div>
        </div>
        <div>
          <button className="btn" onClick={ ()=>onClose() }>
          <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.1194 10.4697L21.637 0.952148C21.7444 0.844727 21.7981 0.71582 21.7981 0.56543C21.7981 0.415039 21.7444 0.286133 21.637 0.178711C21.5295 0.0712891 21.3971 0.0175781 21.2395 0.0175781C21.0891 0.0175781 20.9602 0.0712891 20.8528 0.178711L11.3459 9.68555L1.83911 0.178711C1.73169 0.0712891 1.5992 0.0175781 1.44165 0.0175781C1.29126 0.0175781 1.16235 0.0712891 1.05493 0.178711C0.94751 0.286133 0.893799 0.415039 0.893799 0.56543C0.893799 0.71582 0.94751 0.844727 1.05493 0.952148L10.5725 10.4697L1.05493 19.9766C0.94751 20.084 0.893799 20.2129 0.893799 20.3633C0.893799 20.5137 0.94751 20.6426 1.05493 20.75C1.11222 20.8073 1.1731 20.8467 1.23755 20.8682C1.30916 20.8968 1.3772 20.9111 1.44165 20.9111C1.51326 20.9111 1.5813 20.8968 1.64575 20.8682C1.71737 20.8467 1.78182 20.8073 1.83911 20.75L11.3459 11.2432L20.8528 20.75C20.9101 20.8073 20.9709 20.8467 21.0354 20.8682C21.107 20.8968 21.1786 20.9111 21.2502 20.9111C21.3147 20.9111 21.3792 20.8968 21.4436 20.8682C21.5152 20.8467 21.5797 20.8073 21.637 20.75C21.7444 20.6426 21.7981 20.5137 21.7981 20.3633C21.7981 20.2129 21.7444 20.084 21.637 19.9766L12.1194 10.4697Z" fill="black"/>
          </svg>
          </button>
        </div>
      </header>
      <div className="script-content p-2" dangerouslySetInnerHTML={{ __html:data}}>
      
      </div>

    </div>
  )

}